module.exports = __webpack_public_path__ + "static/media/fruit_jesus_3.42123853.jpeg";